export default {"src":"/_next/static/media/unChekedIcon.2db5afd0.svg","height":14,"width":13,"blurWidth":0,"blurHeight":0};